import { render, staticRenderFns } from "./historicEditor.vue?vue&type=template&id=24dcc21d&"
import script from "./historicEditor.vue?vue&type=script&lang=js&"
export * from "./historicEditor.vue?vue&type=script&lang=js&"
import style0 from "./historicEditor.vue?vue&type=style&index=0&id=24dcc21d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports